<template lang="pug">
  .page-container
    .content
      .container
        .detail(v-html='articleDetail.content')
        .cover
          img(:src='articleDetail.coverPath')
</template>

<script>
import common from "../../api/common.js";

export default {
  data() {
    return {
      articleDetail: {}
    };
  },

  mounted() {
    this.loadArticleDetail();
  },

  methods: {
    async loadArticleDetail() {
      try {
        const res = await common.loadArticleDetail({
          articleId: this.$route.params.id
        });
        if (res.data.status == "fail") {
          this.$toasted.show(res.data.msg);
        } else if (res.data.status == "SUCCESSS") {
          this.articleDetail = res.data.data;
        }
      } catch (e) {
        console.log(e);
      }
    }
  }
};
</script>

<style scoped lang="sass" src="./article.sass"></style>
